export const showStories = ({ showStories }) => showStories

export const stories = ({ stories }) => stories

export const storiesList = ({ storiesList }) => storiesList

export const showProactiveMsg = ({ showProactiveMsg }) => showProactiveMsg

export const selectedStorie = ({ selectedStorie }) => selectedStorie

export const vueperStoriesDisabled = ({ vueperStoriesDisabled }) =>
  vueperStoriesDisabled

export const manualCloseProactiveMessage = ({ manualCloseProactiveMessage }) =>
  manualCloseProactiveMessage
